import { ConsumerEntity } from '../../consumer/consumer.entity';
import { Relation } from '../../core/decorators/relation.decorator';
import { BaseEntity } from '../../core/entities/base.entity';
import { ConsumerData } from '../../core/types';
import { RelationRef } from '../../core/types/entity-types';
import { SequenceEntity } from '../../sequence/sequence.entity';
import { SubjectEntity } from '../../subject/subject.entity';

export interface ExerciseKind {
  value: string
  option: string
}

export interface ExerciseConsumer {
  id: string
  name: string
}

export interface ExerciseCompetency {
  id: string
  name: string
}

interface LearnItemConfig {
  exerciseSubKind?: string
}

export class ExerciseEntity extends BaseEntity {
  subjectId!: string;
  consumerId!: string;
  name!: string;
  kind!: string;
  config!: LearnItemConfig;
  assignments!: string[];
  assets!: string[];
  updated!: Date;
  version!: number;
  approval!: string;
  active!: boolean;
  lastVersion!: string;
  sortName!: string;
  correct!: string[];
  changedBy!: string;
  copyRestricted!: boolean;
  consumerData!: ConsumerData;
  pages!: string[];
  conditionalErrors!: string[];
  quantityErrors!: string[];

  @Relation()
  consumers?: RelationRef<ConsumerEntity>[];

  @Relation()
  subjects?: RelationRef<SubjectEntity>[];

  @Relation()
  sequences?: RelationRef<SequenceEntity>[];
}
